// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxxxlargeOnConfined-superElipse-05fcecc5","strokeWidth":"super-ellipse-skins-xxxxlargeOnConfined-strokeWidth-db64d005"};